export default "__VITE_ASSET__B9Xd_Brx__"